import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { RESOURCE } from '@shared/constant';
import { TooltipPosition } from '@shared/enum/tooltip.enums';
import { CountryCodeService } from 'src/app/services/country-code.service';
import { CurrencyService } from 'src/app/services/currency.service';

@Component({
    selector: 'app-popup-cancel-booking',
    templateUrl: './popup-cancel-booking.component.html',
    styleUrls: ['./popup-cancel-booking.component.scss'],
})
export class PopupCancelBookingComponent {
    @Input() type?: string;
    @Input() flightDetail: any;
    @Input() selectedPassenger: any;
    @Input() isCallAPI?: boolean;
    @Output() cancelEmit = new EventEmitter<any>();
    @Output() nextEmit = new EventEmitter<any>();

    TooltipPosition: typeof TooltipPosition = TooltipPosition;
    cancelForm: FormGroup;
    isShowPopupDiscard: boolean = false;
    isShowPopupConfirm: boolean = false;
    currentFareRule: string;
    currentIndexFareRule: number;
    itineraries: any;
    priceDetails: any;
    baseImage = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;
    fareRuleVi: string;
    resource: string;
    currentSegments: any;
    serviceData = [
        {
            numSeat: 0,
            totalSeat: 0,
            numMeal: 0,
            totalMeal: 0,
            numExtraBaggage: 0,
            totalExtraBaggage: 0,
        },
        {
            numSeat: 0,
            totalSeat: 0,
            numMeal: 0,
            totalMeal: 0,
            numExtraBaggage: 0,
            totalExtraBaggage: 0,
        },
    ];
    totalPrice: number = 0;
    chosenDepart: boolean = false;
    chosenReturn: boolean = false;
    numChosenItinerary: number = 0;
    collapsedStates: any[] = [];
    currency: any;
    priceRefund: number = 0;
    partner: string = '';
    cancelReasonValues = [
        'CHANGE_TRAVEL_PLANS',
        'DISSATISFACTION_BOOKING',
        'FOUND_BETTER_DEAL',
        'HAVE_ANOTHER_BOOKING',
        'PERSONAL_REASONS',
        'TRIP_CALLED_OFF',
        'OTHER_REASON'
    ];

    constructor(
        private fb: FormBuilder,
        private translateService: TranslateService,
        private currencyService: CurrencyService,
        private countryCodeService: CountryCodeService
    ) { }

    ngOnInit() {
        this.currency = JSON.parse(localStorage.getItem('currency-conversation-data') || '');
        this.currencyService.receiveSignalChangeCurrency().subscribe(() => {
            this.currency = JSON.parse(localStorage.getItem('currency-conversation-data') || '');
        });
        this.priceRefund = this.flightDetail.price_details.total_price;

        this.cancelForm = this.fb.group({
            isRefund: [null, [Validators.required]],
            refundAmount: [null],
        });
        // Initialize collapsed states
        if (this.flightDetail?.price_details?.price_details?.length) {
            this.collapsedStates = this.flightDetail.price_details.price_details.map((item: any) => {
                return {
                    summary: true,
                    adult: true,
                    child: true,
                    infant: true,
                    taxes_charges: true,
                    addon: true
                }
            })
        }
        this.itineraries = this.flightDetail?.flight_info?.itineraries;
        this.priceDetails = this.flightDetail?.price_details;

        // Check show flight information and prices
        if (this.selectedPassenger) {
            let firstValid: boolean = false;
            this.selectedPassenger.forEach((item: any, index: number) => {
                if (item.passengers?.length) {
                    this.numChosenItinerary++;
                    if (!firstValid) {
                        this.currentIndexFareRule = index;
                        this.currentSegments = this.itineraries[index]?.segments;
                        this.currentFareRule = this.itineraries[index]?.fare_rule;
                        this.fareRuleVi = this.itineraries[index]?.fare_rule_vi;
                        this.resource = this.itineraries[index]?.resource;
                        firstValid = true;
                    }
                    this.totalPrice += this.priceDetails?.price_details?.[index]?.final_price;
                } else {
                    this.priceRefund -= this.priceDetails?.price_details?.[index]?.final_price;
                }
            });
            if (this.flightDetail?.price_details?.vouchers?.length) {
                this.flightDetail.price_details.vouchers.forEach((item: any) => {
                    this.totalPrice -= item.discount_price;
                })
            }
        }
        // Auto fill refund amount
        if (this.type === 'REQUEST_REFUND') {
            this.cancelForm.patchValue({
                refundAmount: (this.priceRefund > 0 ? this.priceRefund : 0)
            });
        }
        // Format num and price addon
        this.formatAddOns(this.flightDetail?.passenger_information);
        // Load partner
        this.loadPartner(this.flightDetail.booking_info);
    }

    get f(): { [key: string]: AbstractControl } {
        return this.cancelForm.controls;
    }

    formatAddOns(passengers: any) {
        passengers.forEach((passenger: any) => {
            // SEAT
            if (passenger?.departure_seat?.length) {
                this.serviceData[0].numSeat += passenger.departure_seat.length;
                passenger.departure_seat.forEach((seat: any) => {
                    this.serviceData[0].totalSeat += seat.price;
                });
            }
            if (passenger?.return_seat?.length) {
                this.serviceData[1].numSeat += passenger.return_seat.length;
                passenger.return_seat.forEach((seat: any) => {
                    this.serviceData[1].totalSeat += seat.price;
                });
            }
            // EXTRA_BAGGAGE
            if (passenger?.departure_extra_baggage?.length) {
                this.serviceData[0].numExtraBaggage +=
                    passenger.departure_extra_baggage.length;
                passenger.departure_extra_baggage.forEach((baggage: any) => {
                    this.serviceData[0].totalExtraBaggage += baggage.price;
                });
            }
            if (passenger?.return_extra_baggage?.length) {
                this.serviceData[1].numExtraBaggage +=
                    passenger.return_extra_baggage.length;
                passenger.return_extra_baggage.forEach((baggage: any) => {
                    this.serviceData[1].totalExtraBaggage += baggage.price;
                });
            }
            // MEAL
            if (passenger?.departure_meals?.length) {
                passenger.departure_meals.forEach((segment: any) => {
                    if (segment.meals?.length) {
                        segment.meals.forEach((meal: any) => {
                            this.serviceData[0].numMeal += meal.quantity;
                            this.serviceData[0].totalMeal += meal.price;
                        });
                    }
                });
            }
            if (passenger?.return_meals?.length) {
                passenger.return_meals.forEach((segment: any) => {
                    if (segment.meals?.length) {
                        segment.meals.forEach((meal: any) => {
                            this.serviceData[1].numMeal += meal.quantity;
                            this.serviceData[1].totalMeal += meal.price;
                        });
                    }
                });
            }
        });
    }

    toggleCollapse(index: number, key: string) {
        this.collapsedStates[index][key] = !this.collapsedStates[index][key];
    }

    formatTime(timeString: string): string {
        const timeParts = timeString.split(':');
        const date = new Date();
        date.setHours(Number(timeParts[0]));
        date.setMinutes(Number(timeParts[1]));

        return date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    }

    formatDuration(timeString: string, space: boolean): string {
        const timeParts = timeString.split(':');
        const hours = Number(timeParts[0]);
        const minutes = Number(timeParts[1]);

        let formattedDuration = '';

        if (hours > 0) {
            if (space) {
                formattedDuration += `${hours}h `;
            } else {
                formattedDuration += `${hours}h`;
            }
        }

        formattedDuration += `${minutes}m`;

        return formattedDuration;
    }

    formatBaggages(baggage: any): string {
        if (baggage?.number && baggage?.weight) {
            return `${baggage?.number}x${baggage?.weight} ${baggage?.unit}`;
        } else if (baggage?.number && baggage?.weight == null) {
            return `${baggage?.number} ${this.translateService.instant('COMMON.PCS')}`;
        } else if (baggage?.number == null && baggage?.weight) {
            return `${baggage?.weight} ${baggage?.unit}`;
        } else if (baggage?.description == 'included') {
            return this.translateService.instant('FLIGHT.VIEW_DETAILS_SIDEBAR.INCLUDED');
        } else
            return '';
    }

    toggleFareRule(index: number) {
        this.currentIndexFareRule = index;

        const itinerary = this.itineraries[index];
        if (itinerary) {
            this.currentSegments = itinerary?.segments;
            this.currentFareRule = itinerary.fare_rule;
            this.fareRuleVi = itinerary.fare_rule_vi;
            this.resource = itinerary.resource
        }
    }

    onChangeYesOrNo(value: boolean) {
        const refundAmountControl = this.cancelForm.get('refundAmount');

        if (value) {
            refundAmountControl?.setValidators([Validators.required, Validators.max(this.flightDetail.price_details.total_price)]);
        } else {
            refundAmountControl?.clearValidators();
        }

        refundAmountControl?.updateValueAndValidity();
    }

    onClickCancel() {
        this.isShowPopupDiscard = true;
    }

    onClickConfirm() {
        if (this.cancelForm.valid) {
            this.isShowPopupConfirm = true;
        } else {
            this.cancelForm.markAllAsTouched();
            setTimeout(() => {
                this.scrollToFirstInvalidControl();
            }, 0);
        }
    }

    private scrollToFirstInvalidControl() {
        let form = document.getElementById('cancelForm');
        let firstInvalidControl = form!.getElementsByClassName('is-invalid')[0];
        if (firstInvalidControl) {
            firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            (firstInvalidControl as HTMLElement).focus();
        }
    }

    onKeepEditing() {
        this.isShowPopupDiscard = false;
        this.isShowPopupConfirm = false;
    }

    onDiscard() {
        // event.stopPropagation();
        this.isShowPopupDiscard = false;
        this.cancelEmit.emit();
    }

    onForceConfirm() {
        this.isShowPopupConfirm = false;
        this.nextEmit.emit(this.cancelForm.value);
    }

    replaceWithDefaultImage(event: any): void {
        event.target.src = 'assets/images/user-management/default-image.jpg';
    }

    loadPartner(bookingInfo: any) {
        const indexFail = this.flightDetail?.request_detail?.request_process?.[0]?.failed_itinerary_indices?.[0] || 0;

        if (indexFail == 0) {
            this.partner = RESOURCE[bookingInfo?.resource] || bookingInfo.resource;
        } else {
            this.partner = RESOURCE[bookingInfo?.inbound_resource] || bookingInfo.inbound_resource;
        }
    }

    isPredefinedReason(note: string | null | undefined): boolean {
        return !!note && this.cancelReasonValues.includes(note);
    }

    getUTCUser() {
        return this.countryCodeService.getUTCOffset();
    }
}
